import { render, staticRenderFns } from "./Fishbowl.vue?vue&type=template&id=958a3cd2&scoped=true"
import script from "./Fishbowl.vue?vue&type=script&lang=ts"
export * from "./Fishbowl.vue?vue&type=script&lang=ts"
import style0 from "./Fishbowl.vue?vue&type=style&index=0&id=958a3cd2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958a3cd2",
  null
  
)

export default component.exports